import { InjectionToken } from "@angular/core";

export const NOTIFICATION_APP_ID = new InjectionToken<string>('OneSignal Notification App ID');
export const NOTIFICATION_GOOGLE_PROJECTNO = new InjectionToken<string>('Google GCM Project Number');

export abstract class NgNotificationService {
    abstract init(enable: boolean): void;
}
